import Vue from 'vue';
import {API_ROOT} from '../config'

export default Vue.resource(API_ROOT + 'delivery-note', {});



// WEBPACK FOOTER //
// ./client/resources/deliveryNoteResource.js